import React from "react";
import s from "./Grid.module.scss";

const Grid = ({ gridId, collapse, children }) => {
  return (
    <div id={gridId} className={[s.col, collapse ? s.collapse : ""].join(" ")}>
      {children}
    </div>
  );
};

export default React.memo(Grid);
